var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { TableHeading } from '@/typings';
// date libs
import * as format from 'date-fns/format';
// dependency-injection
import { TYPES } from '@/dependency-injection/types';
import { lazyInject } from '@/dependency-injection';
import { OpportunityActionsService } from '@/services/opportunity-management/opportunity-actions-service';
import TableMixin from '@/mixins/table-mixin';
import ItemsMixin from '@/mixins/items-mixin';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import UpMarketOpportunities from '@/pages/opportunity-management/opportunity-actions/components/UpMarketOpportunities.vue';
import DownMarketOpportunities from '@/pages/opportunity-management/opportunity-actions/components/DownMarketOpportunities.vue';
import NeutralMarketOpportunities from '@/pages/opportunity-management/opportunity-actions/components/NeutralMarketOpportunities.vue';
import InactiveActions from '@/pages/opportunity-management/opportunity-actions/components/InactiveActions.vue';
var OpportunityActionsTable = /** @class */ (function (_super) {
    __extends(OpportunityActionsTable, _super);
    function OpportunityActionsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mobileExpanded = false;
        _this.action = '';
        _this.siteId = '';
        _this.headers = [
            new TableHeading('Site', 'siteId'),
            new TableHeading('Market', 'marketId'),
            new TableHeading('Index', 'plattsRegion'),
            new TableHeading('Up Market Actions #', 'upMarketActions'),
            new TableHeading('Down Market Actions #', 'downMarketActions'),
            new TableHeading('Neutral Actions', 'siteId', false),
            new TableHeading('Opportunity Inaction', 'noActions'),
            new TableHeading('Action Taken?', 'actionsTaken'),
        ];
        return _this;
    }
    OpportunityActionsTable.prototype.beforeMount = function () {
        this.serviceSymbol = TYPES.OpportunityActionsService;
    };
    OpportunityActionsTable.prototype.openInactionSidesheet = function (item) {
        var data = {
            siteId: item.siteId,
            date: this.filterDate,
            reason: item.noActionsReason,
            other: item.comments,
        };
        this.openCrudSidesheetCreate(data);
    };
    OpportunityActionsTable.prototype.loadOpportunitiesMobile = function (item, type) {
        var _this = this;
        this.siteId = item.siteId;
        // same as current action, therefore toggle only
        if (this.action === type && this.mobileExpanded) {
            this.action = '';
            this.mobileExpanded = false;
            return;
        }
        // set the new action, and expand row
        this.$nextTick(function () {
            _this.action = type;
            if (_this.action === _this.inactionAction && _this.mobileExpanded === false) {
                _this.openInactionSidesheet(item);
            }
            else {
                _this.closeCrudSidesheet();
            }
            _this.mobileExpanded = !_this.mobileExpanded;
        });
    };
    // ~ fix dropdowns not toggling as expected
    OpportunityActionsTable.prototype.loadOpportunities = function (siteId, type, expanded, expandRowCallback) {
        var _this = this;
        this.siteId = siteId;
        // was previously set, close previous
        if (this.action !== '') {
            this.action = '';
            expandRowCallback();
        }
        // set the new action, and expand row
        this.$nextTick(function () {
            _this.action = type;
            _this.closeCrudSidesheet();
            expandRowCallback();
        });
    };
    OpportunityActionsTable.prototype.refreshActions = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.opportunityActionsService.getOpportunityActionSummaries(format(payload.date, 'YYYY-MM-DD'), null, null, payload.siteId)];
                    case 1:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        if (response.data.length !== 1) {
                            this.showSnackbar({ text: 'Unable to refresh action counts for site', color: 'warning' });
                            return [2 /*return*/];
                        }
                        this.updateItemsCollection(response.data[0], ['siteId']);
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OpportunityActionsTable.prototype, "upAction", {
        get: function () {
            return 'UP';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityActionsTable.prototype, "downAction", {
        get: function () {
            return 'DOWN';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityActionsTable.prototype, "neutralAction", {
        get: function () {
            return 'NEUTRAL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityActionsTable.prototype, "inactionAction", {
        get: function () {
            return 'INACTION';
        },
        enumerable: false,
        configurable: true
    });
    OpportunityActionsTable.prototype.customSearchFilter = function (value, search, item) {
        search = search.toLowerCase();
        return ((item.siteId && item.siteId.toLowerCase().includes(search)) ||
            (item.siteName && item.siteName.toLowerCase().includes(search)) ||
            (item.marketId && item.marketId.toLowerCase().includes(search)));
    };
    var _a, _b;
    __decorate([
        lazyInject(TYPES.OpportunityActionsService),
        __metadata("design:type", typeof (_a = typeof OpportunityActionsService !== "undefined" && OpportunityActionsService) === "function" ? _a : Object)
    ], OpportunityActionsTable.prototype, "opportunityActionsService", void 0);
    __decorate([
        Prop({ type: [Date, String], required: true }),
        __metadata("design:type", Object)
    ], OpportunityActionsTable.prototype, "filterDate", void 0);
    OpportunityActionsTable = __decorate([
        Component({
            components: {
                'up-market-opportunities': UpMarketOpportunities,
                'down-market-opportunities': DownMarketOpportunities,
                'neutral-market-opportunities': NeutralMarketOpportunities,
                'inactive-actions': InactiveActions,
            },
        })
    ], OpportunityActionsTable);
    return OpportunityActionsTable;
}(Mixins(TableMixin, ItemsMixin, SnackbarMixin)));
export default OpportunityActionsTable;
